// PermissionManager.js

let permissions = [];
let roles = [];

export const initPermissions = () => {
  try {
    const storedPermissions = localStorage.getItem("permissions");
    const storedRoles = localStorage.getItem("roles");
    permissions = storedPermissions ? JSON.parse(storedPermissions) : [];
    roles = storedRoles ? JSON.parse(storedRoles) : [];
  } catch (error) {
    permissions = [];
    roles = [];
  }
};

export const setPermissions = (permissionList = []) => {
  permissions = permissionList;
  localStorage.setItem("permissions", JSON.stringify(permissionList));
};

export const setRoles = (roleList = []) => {
  roles = roleList;
  localStorage.setItem("roles", JSON.stringify(roleList));
};

export const getPermissions = () => permissions;
export const getRoles = () => roles;

export const hasPermission = (permission) => {
  if (!permission) return true;
  return permissions.includes(permission);
};

export const hasAnyPermission = (permissionList = []) => {
  if (!permissionList.length) return true;
  return permissionList.some((p) => permissions.includes(p));
};

export const hasRole = (role) => roles.includes(role);

export const clearPermissions = () => {
  permissions = [];
  roles = [];
  localStorage.removeItem("permissions");
  localStorage.removeItem("roles");
};
